import getConfig from '../config';
var config = getConfig();
var checkIsBucketRegexp = new RegExp("https://(".concat(config.aws.labelBucket, "|").concat(config.aws.mediaBucket, ").s3.").concat(config.aws.region, ".amazonaws.com/"), 'g');
var checkIsBucket = function (url) { return url.match(checkIsBucketRegexp); };
export default checkIsBucket;
//# sourceMappingURL=checkIsBucket.js.map